import { Injectable } from '@angular/core';
import { UserdataService } from './userdata.service';
import { UmbrellaService } from './umbrella.service';
import { ProductEntitlementsService } from './product-entitlements.service';
import { DownloadHelperService } from './download-helper.service';
import { ClassEnrollmentService } from './class-enrollments.service';

@Injectable()
export class StudentBookService {

    constructor(
        private userdataService: UserdataService,
        private productEntitlementsService: ProductEntitlementsService,
        private umbrellaService: UmbrellaService,
        private downloadHelperService: DownloadHelperService,
        private classEnrollmentService: ClassEnrollmentService
    ) {

    }

    get downloadedList() {
        return this.downloadHelperService.downloadedList;
    }

    get peDownloadedList() {
        return this.downloadHelperService.peDownloadedList;
    }

    /**
     * This is the studentbook code that comes from the server as productCode.
     */
    public getProductInfo(productcode) {
        let productUmbrella;
        let user = this.userdataService.getLoggedInUser();
        //Get product data from product Code
        if (user.role == 'teacher') {
            productUmbrella = this.umbrellaService.getUmbrellaofProduct(productcode);
        } else if (user.role == 'student') {
            productUmbrella = this.productEntitlementsService.getUmbrellaofProduct(productcode);
        }
        //Combine downloaded and location info
        let downloadedInfo = this.downloadedList.get(productcode);
        let downloadDetails: any = { downloaded: false };
        if (downloadedInfo && downloadedInfo.usersWithAccess.indexOf(user.uid) > -1) {
            downloadDetails = {
                downloaded: true,
                location: downloadedInfo.location
            }
        }
        return {
            productUmbrella,
            downloadDetails
        };
    }

    public getUserSpaces(user){
        return this.classEnrollmentService.fetchSavedSpacesFromDB(user);
    }

}